import { Config } from '../config';

export const useConsoleLog = () => {
    const log = (props: any) => {
        if (!Config.IsProd) {
            console.log(props)
        }
    }
    return { log }
}